<div class="grid w-full items-center" style="grid-template-columns: 1fr auto 1fr" animate.enter="anim-fade-from-bottom">
  <div class="flex justify-end">
    <div class="bg-surface-100 grid grid-cols-4 content-start gap-2 rounded-md p-2">
      @for (value of prefixes; track value) {
        <button type="button" [class]="tileClasses('A', prefixDisabled())" [disabled]="prefixDisabled()" (click)="pressPrefix(value)">
          {{ value }}
        </button>
      }
    </div>
  </div>

  <div class="mx-1 inline-flex h-full items-center px-4 py-4 text-3xl text-slate-300 select-none">⋯</div>

  <div class="flex justify-start">
    <div class="flex flex-col gap-2">
      <div class="bg-surface-100 grid grid-cols-4 gap-2 rounded-md p-2">
        @for (value of suffixesA; track value) {
          <button type="button" [class]="tileClasses('A', suffixDisabled())" [disabled]="suffixDisabled()" (click)="pressSuffix(value)">
            {{ value }}
          </button>
        }
      </div>

      <div class="bg-surface-100 grid grid-cols-4 gap-2 rounded-md p-2">
        @for (value of suffixesB; track value) {
          <button type="button" [class]="tileClasses('B', suffixDisabled())" [disabled]="suffixDisabled()" (click)="pressSuffix(value)">
            {{ value }}
          </button>
        }
      </div>
    </div>
  </div>
</div>
